/**
 * misc small js functions.
 *
 * This file will always be the last to be included!
 */

jQuery(document).ready(function () {
    jQuery('button.add-permission').addPermission();
    jQuery('span.tooltip-holder').tooltip();
    jQuery('button.service-toggle').toggleAccess();
});
